import { ApiError } from '@app/shared/models/api/api-error.model';
import { FeaturedReviewStatsModel } from '@app/shared/models/api/featured-review-stats.model';
import { FeaturedReviewModel } from '@app/shared/models/api/featured-review.model';

export interface TimerComponents {
  secondsToDday: number;
  minutesToDday: number;
  hoursToDday: number;
  daysToDday: number;
}

export interface AkitaFeaturedState {
  featuredReviews: {
    [lang: string]: {
      [model: string]: Array<FeaturedReviewModel>;
    };
  };

  featuredReviewsStats: {
    [lang: string]: {
      [model: string]: FeaturedReviewStatsModel;
    };
  };

  errorFetchingFeaturedReviews: {
    [lang: string]: ApiError | null;
  };

  fetchingFeaturedReviews: {
    [lang: string]: boolean;
  };
}

export function createInitialFeaturedState(): AkitaFeaturedState {
  return {
    featuredReviews: {},
    featuredReviewsStats: {},
    errorFetchingFeaturedReviews: {},
    fetchingFeaturedReviews: {},
  };
}
